import AboutIndex from 'views/About/AboutIndex';
import CategoriesIndex from 'views/Categories/CategoriesIndex';
import CelebritiesIndex from 'views/Celebrities/CelebritiesIndex';
import CollectionsIndex from 'views/Collections/CollectionsIndex';
import Dashboard from 'views/Dashboard/Dashboard.jsx';
import PressKitsIndex from 'views/PressKits/PressKitsIndex';
import RolesIndex from 'views/Roles/RolesIndex';
import UsersIndex from 'views/Users/UsersIndex';
import VideosIndex from 'views/Videos/VideosIndex';
import AboutForm from '../views/About/AboutForm';
import CategoriesForm from '../views/Categories/CategoriesForm';
import CelebritiesForm from '../views/Celebrities/CelebritiesForm';
import CollectionsForm from '../views/Collections/CollectionsForm';
import PressKitsForm from '../views/PressKits/PressKitsForm';
import RolesForm from '../views/Roles/RolesForm';
import UsersForm from '../views/Users/UsersForm';
import VideosForm from '../views/Videos/VideosForm';

// var pages = [
//     { path: '/user-page', name: 'User Page', mini: 'UP', component: UserPage }
// ].concat(pagesRoutes);

var dashboardRoutes = [
  {
    path: '/admin/dashboard',
    name: 'Inicio',
    icon: 'pe-7s-graph',
    component: Dashboard
  },
  {
    path: '/admin/about/:id',
    name: 'Biografía',
    component: AboutForm,
    invisible: true
  },
  {
    path: '/admin/about',
    name: 'Biografía',
    icon: 'pe-7s-user',
    component: AboutIndex
  },
  {
    path: '/admin/categories/:id',
    name: 'Categorías',
    component: CategoriesForm,
    invisible: true
  },
  {
    path: '/admin/categories',
    name: 'Categorías',
    icon: 'pe-7s-folder',
    component: CategoriesIndex
  },
  {
    path: '/admin/celebrities/:id',
    name: 'Celebridades',
    component: CelebritiesForm,
    invisible: true
  },
  {
    path: '/admin/celebrities',
    name: 'Celebridades',
    icon: 'pe-7s-star',
    component: CelebritiesIndex
  },
  {
    path: '/admin/collections/:id',
    name: 'Colecciones',
    component: CollectionsForm,
    invisible: true
  },
  {
    path: '/admin/collections',
    name: 'Colecciones',
    icon: 'pe-7s-albums',
    component: CollectionsIndex
  },
  {
    path: '/admin/press-kits/:id',
    name: 'Prensa',
    component: PressKitsForm,
    invisible: true
  },
  {
    path: '/admin/press-kits',
    name: 'Prensa',
    icon: 'pe-7s-news-paper',
    component: PressKitsIndex
  },
  {
    path: '/admin/videos/:id',
    name: 'Videos',
    component: VideosForm,
    invisible: true
  },
  {
    path: '/admin/videos',
    name: 'Videos',
    icon: 'pe-7s-film',
    component: VideosIndex
  },
  {
    collapse: true,
    path: '/admin/support',
    name: 'Soporte',
    state: 'openSupport',
    icon: 'pe-7s-help1',
    views: [
      {
        path: '/admin/users/:id',
        name: 'Usuarios',
        component: UsersForm,
        invisible: true
      },
      {
        path: '/admin/users',
        name: 'Usuarios',
        icon: 'pe-7s-users',
        component: UsersIndex
      },
      {
        path: '/admin/support/roles/:id',
        name: 'Roles',
        component: RolesForm,
        invisible: true
      },
      {
        path: '/admin/support/roles',
        name: 'Roles',
        icon: 'pe-7s-lock',
        component: RolesIndex
      }
    ]
  },
  { redirect: true, path: '/', pathTo: '/admin/dashboard', name: 'Inicio' }
];
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx